export const accountTypes = ["Estimator", "Installer", "Fabricator"];
